import DialogView from "../../dialog/Dialog.view.tsx";
import { useTranslation } from "react-i18next";
import styles from "./UserResetPassword.desktop.module.css";
import React from "react";
import LoaderView from "../../../components/loader/Loader.view.tsx";
import type UserResetPasswordProperties from "../UserResetPassword.properties.ts";
import { useUserResetPasswordController } from "../UserResetPassword.controller.ts";
import InputView from "../../../components/input/Input.view.tsx";

export default function UserResetPasswordDesktopView(
  props: UserResetPasswordProperties,
) {
  const { t } = useTranslation();
  const {
    loading,
    handleSave,
    enableSaveButton,
    password,
    setPassword,
    repeatPassword,
    setRepeatPassword,
  } = useUserResetPasswordController(props);

  return (
    <DialogView
      header={t("ui.userResetPasswordDialogHeader")}
      onBackdrop={props.handleDialogCloseClick}
    >
      <div>
        <>
          {loading && <LoaderView />}

          {!loading && (
            <>
              <table className={styles.table}>
                <tbody>
                  <tr>
                    <td className={styles.tdKey}>{t("ui.password")}</td>
                    <td className={styles.tdValue}>
                      <InputView
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        type="password"
                        width={248}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className={styles.tdKey}>{t("ui.repeatPassword")}</td>
                    <td className={styles.tdValue}>
                      <InputView
                        value={repeatPassword}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                        type="password"
                        width={248}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className={styles.buttonContainer}>
                <button
                  className={styles.buttonSave}
                  onClick={handleSave}
                  disabled={!enableSaveButton()}
                >
                  {t("ui.save")}
                </button>
              </div>
            </>
          )}
        </>
      </div>
    </DialogView>
  );
}
